import { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { Header } from './components/Header'
import { MAIN_SITE } from './lib/site'
import { Home } from './pages/Home'
import { Records } from './pages/Records'
import { Update } from './pages/Update'
import { AuthCallback } from './pages/AuthCallback'
import { NotFound } from './pages/NotFound'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <span>PageDrop · {t('footer.slogan')}</span>
        <span className="footer-note">
          <Trans
            i18nKey="footer.note"
            components={[
              <a href={MAIN_SITE} target="_blank" rel="noreferrer" aria-label="一方工具箱" />,
            ]}
          />
        </span>
      </div>
    </footer>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/records" element={<Records />} />
        <Route path="/update/:id" element={<Update />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
